import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';

const Message = ({ color, timeout, children, fullWidth }) => {
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		if (color === 'success') {
			setTimeout(() => {
				setVisible(false);
			}, 5000);
		}
	}, [color]);
	const onDismiss = () => setVisible(false);

	if (fullWidth) {
		return (
			<div className='mt-2 mx-auto w-100'>
				<Alert color={color} isOpen={visible} toggle={onDismiss}>
					{children}
				</Alert>
			</div>
		);
	} else {
		return (
			<div className='mt-2 mx-auto w-50'>
				<Alert color={color} isOpen={visible} toggle={onDismiss}>
					{children}
				</Alert>
			</div>
		);
	}
};

//<div
//className={`alert alert-${color} alert-dismissible fade show pb-3`}
//role='alert'>
//{children}
//<button
//	type='button'
//	className='btn-close'
//	data-bs-dismiss='alert'
//	aria-label='Close'></button>
//</div>

export default Message;
